export default __webpack_public_path__ + "static/PCI-379d0d736a7aad17e47d456e7ba2e131.svg";